import * as CookieConsent from "vanilla-cookieconsent"

import GoogleMap from "../modules/GoogleMap"

class AppManager {
    constructor() {
        this.apps = {}
        this.cookieHint = document.querySelector(".cookie-hint")

        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: 'box inline',
                    position: 'bottom left',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
                preferencesModal: {
                    layout: 'box',
                    equalWeightButtons: true,
                    flipButtons: false,
                },
            },

            categories: {
                necessary: {
                    readOnly: true,
                    enabled: true,
                },

                analytics: {
                    services: {
                        googlemaps: {
                            label: 'Google Maps Embed',
                            onAccept: () => {
                                if (this.cookieHint) {
                                    this.cookieHint.classList.add('hide')
                                }

                                if (!this.apps['googlemaps']) {
                                    this.apps['googlemaps'] = new GoogleMap()
                                }
                            },
                            onReject: () => {
                                if (this.apps['googlemaps']) {
                                    delete this.apps['googlemaps']
                                }

                                location.reload()
                            },
                        },
                    },
                },

                ads: {},
            },

            language: {
                default: 'de',
                autoDetect: 'document',

                translations: {
                    de: '/cookie-consent?lang=de',
                    en: '/cookie-consent?lang=en',
                    zh: '/cookie-consent?lang=zh',
                },
            },
        });
    }
}

export default AppManager;